module.exports = __webpack_public_path__ + "static/img/20260309-1.3fea43c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20260309-1.jpg
// module id = hBML
// module chunks = 100